<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование MetaPages" : "Добавление MetaPages"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          h3()  Автоподстановочные шаблоны для строк:
        v-flex(xs12)
          ul
            li  {%City%} - Город (регион) в именительном падеже
            li  {%inCity%} - Город (регион) в дательном падеже
            li  {%Phone%} - Основной номер региона
  v-tabs( color='dark', slider-color='primary')
    v-tab Метаданные
    v-tab-item(:transition='false', :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              s-publish-date-status(
                :errors='errors'
                :model='model'
                label='Опубликовано'
              )
            v-flex(xs12)
              s-sites-picker(
                v-model='sites'
                multiple
                chips
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("front_url")'
                :error-messages='errors.first("front_url")'
                v-model='model.front_url'
                label='URL страницы'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("meta_h1")'
                :error-messages='errors.first("meta_h1")'
                v-model='model.meta_h1'
                label='H1 страницы. Работает не для всех страниц. На отдельных страницах определяется контентом сущности страницы.'
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("meta_title")'
                :error-messages='errors.first("meta_title")'
                v-model='model.meta_title'
                label='TITLE страницы'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("meta_description")'
                :error-messages='errors.first("meta_description")'
                v-model='model.meta_description'
                label='DESCRIPTION страницы'
              )
            v-flex(xs12)
              v-select(
                v-if='attributes'
                :error='errors.has("faqgroup_id")'
                :error-messages='errors.first("faqgroup_id")'
                :items='attributes.faq_groups'
                item-text='name'
                item-value='id'
                v-model='model.faqgroup_id'
                label='Группа FAQ'
                clearable
              )
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            @click='onSave'
            :loading='isLoading'
            color='primary'
            depressed
          ) Сохранить
    v-tab(v-if='id') Микро: Мероприятия
    v-tab-item(v-if='id' :transition='false', :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            div(class="add-block")
              v-btn(
                @click='onAddMicroEvent'
                :style='{ margin: 0 }'
                :disabled = 'microEvents.length>=maxEvents'
                depressed
              ) Добавить мероприятие
            v-flex(xs12)
              v-layout(wrap)
                v-flex(
                  v-for='(event,index) in microEvents'
                  :key='event.id'
                  xs12
                  class='micro-event'
                )
                  v-layout(wrap)
                    v-flex(xs12)
                      span() Строка № {{ index+1 }}
                    v-flex(xs6)
                      v-text-field(
                        label='Название мероприятия (Event.Name)'
                        v-model='microEvents[index].eventName'
                      )
                    v-flex(xs6)
                      v-text-field(
                        label='Описание мероприятия (Event.Description)'
                        v-model='microEvents[index].eventDescription'
                      )
                    v-flex(xs6)
                      v-text-field(
                        label='Об организаторе (Event.About)'
                        v-model='microEvents[index].eventAbout'
                      )
                    v-flex(xs2)
                      v-text-field(
                        label='Цена предложения (Offer.Price)'
                        v-model='microEvents[index].offerPrice'
                      )
                    v-flex(xs4)
                      v-text-field(
                        label='Название локации мероприятия (Location.Name)'
                        v-model='microEvents[index].locationName'
                      )
                    v-flex(xs4)
                      v-text-field(
                        label='Город (addressLocality)'
                        v-model='microEvents[index].addressLocality'
                      )
                    v-flex(xs4)
                      v-text-field(
                        label='Регион (addressRegion)'
                        v-model='microEvents[index].addressRegion'
                      )
                    v-flex(xs4)
                      v-text-field(
                        label='Адрес (streetAddress)'
                        v-model='microEvents[index].streetAddress'
                      )
                    v-layout(class='block-actions')
                      v-flex(xs12)
                        v-btn(
                            @click='onCopyMicroEvent(index)'
                            depressed
                          ) Копировать
                        v-btn(
                          @click='onRemoveMicroEvent(index)'
                          depressed
                        ) Удалить
        v-card-actions(class='large')
          v-spacer
          v-btn(
            @click='onSaveMicroEvents'
            :loading='isLoading'
            color='primary'
            depressed
          ) Сохранить разметку
    v-tab(v-if='id') Микро: Продукт
    v-tab-item(v-if='id' :transition='false', :reverse-transition='false')
      v-card
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs6)
              v-text-field(
                  label='Название раздела (Rating.Name)'
                  v-model='microProduct.name'
                )
            v-flex(xs6)
              v-text-field(
                label='Количество предложений (Rating.offerCount)'
                v-model='microProduct.offerCount'
              )
            v-flex(xs6)
              v-text-field(
                label='Минимальная цена (Rating.lowPrice)'
                v-model='microProduct.lowPrice'
              )
            v-flex(xs6)
              v-text-field(
                label='Максимальная цена (Rating.highPrice)'
                v-model='microProduct.highPrice'
              )
            v-flex(xs6)
              v-text-field(
                label='Рейтинг (Rating.ratingValue)'
                v-model='microProduct.ratingValue'
              )
            v-flex(xs6)
              v-text-field(
                label='Количество голосов (Rating.ratingCount)'
                v-model='microProduct.ratingCount'
              )
        v-card-actions(class='large')
          v-spacer
          v-btn(
            @click='onSavemicroProduct'
            :loading='isLoading'
            color='primary'
            depressed
          ) Сохранить рейтинг
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import http from "@/http"

export default {
  props: ['id'],

  data: () => ({
    model: {},
    attributes: {},
    microProduct: {},
    microEvents: [],
    maxEvents: 3
  }),

  async created() {
    this.fetchAttributes()
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async fetchAttributes() {
      try {
        const res = await http.get('/seo/corppages/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
      this.initEvents()
      this.initRating()
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Seo.MetaPages' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onSaveMicroEvents() {
      try {
        if (this.id) {
          await http.patch(`corppages/${this.id}/microevents`, {
            micro_events: JSON.stringify(this.microEvents)
          })
          this.$root.showSnack('Сохранено')
        }
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async onSavemicroProduct() {
      try {
        if (this.id) {
          await http.patch(`corppages/${this.id}/microproduct`, {
            micro_product: JSON.stringify(this.microProduct)
          })
          this.$root.showSnack('Сохранено')
        }
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    initEvents() {
      if(this.model.micro_events) {
        this.microEvents = JSON.parse(this.model.micro_events)
      }
    },
    
    initRating() {
      if(this.model.micro_product) {
        this.microProduct = JSON.parse(this.model.micro_product)
      }
    },

    onAddMicroEvent() {
      var getEvent = () => ({
        eventName: null,
        eventDescription: null,
        locationName: null,
        addressLocality: null,
        addressRegion: null,
        streetAddress: null,
        eventAbout: null,
        offerPrice: null
      })

      var newEvent = getEvent()
      this.microEvents.push(newEvent)
    },

    onCopyMicroEvent(index) {
      var getEvent = () => ({
        eventName: null,
        eventDescription: null,
        locationName: null,
        addressLocality: null,
        addressRegion: null,
        streetAddress: null,
        eventAbout: null,
        offerPrice: null
      })

      var newEvent = getEvent()

      for (let key in this.microEvents[index]) {
        newEvent[key] = this.microEvents[index][key];
      }

      this.microEvents.push(newEvent)
    },

    async onRemoveMicroEvent(index) {
      if (await this.$confirm('Удалить мероприятие?')) {
        this.microEvents.splice(index, 1)
      }
    },

    ...mapActions('seo/metaPages', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    sites: {
      get() {
        let { site_ids } = this.model
        if (!site_ids) return []
        return site_ids.split(/,/).map(x => +x)
      },

      set(val) {
        this.model.site_ids = val.join(',')
      }

    },
    ...mapGetters('seo/metaPages', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
.micro-event {
  margin-bottom: 20px;
  border-bottom: 2px dotted;
}
</style>
